import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {tagItemsList} from "../../data/data.types";

@Component({
  selector: 'as-tag-list',
  templateUrl: './tag-list.component.html',
  styleUrls: ['./tag-list.component.scss']
})
export class TagListComponent implements OnInit {

  @Input() placeholder;
  @Input() list;
  @Input() subText: boolean = false;
  @Input() hideFiled: boolean = false;
  @Output() updatedList = new EventEmitter();

  tagList: tagItemsList[] = [];
  textInput: string = "";
  error: boolean = false;
  errorString: string = ""

  constructor() {
  }

  ngOnInit() {
    if (this.list && this.list.length > 0) {
      this.tagList = this.list
    }
  }

  addToList() {

    this.errorString = "";
    this.error = false;

    if (this.textInput != "") {

      let splitArr = this.textInput.split(/[, ]+/);

      if (splitArr.length > 0) {
        splitArr.forEach((i) => {
          if (!this.itemExists(i.trim())) {
            this.tagList.push({name: i.trim(), id: null})
          } else {
            this.error = true;
            this.errorString = i;
          }
        })
      } else {
        if (!this.itemExists(splitArr[0].trim())) {
          this.tagList.push({name: splitArr[0].trim(), id: null})
        } else {
          this.error = true;
          this.errorString = splitArr[0];
        }
      }

      this.textInput = "";
      this.updatedList.emit({added: splitArr, final: this.tagList})
    }
  }

  removeFromList(item: tagItemsList) {
    let payload = {}
    let it = this.tagList.findIndex((i) => i == item);

    payload = {removed: this.tagList[it], final: this.tagList}
    this.tagList.splice(it, 1)
    this.updatedList.emit(payload);

  }

  itemExists(item) {
    return this.tagList.some((i) => i.name == item);
  }

  public clearList(){
    this.tagList = [];
  }

}

